module.exports = __webpack_public_path__ + "img/6.a3472916.png";